import React, {Component, Fragment} from 'react';
import {BeatLoader} from 'react-spinners'
import {get,post,postResponse} from "../../../server/actions";
import NotificationSystem from 'react-notification-system';
import ReactTable from "react-table";
import Modal from 'react-modal';
import data from './sampleSchoolData'
import PropTypes from 'prop-types';
import moment from 'moment';
import Toggle from 'react-toggle';
import $ from 'jquery'
import {_addNotification, _addNotificationError, getModuleEnum, getAccessLevelByModule, numberParce, sortGrade, getSchoolGrades} from '../../../server/util';
import {date_format} from '../../../server/constants'
import CustomSubmit from './../../Misc/customSubmit'
import {STUDENT_IMPORT_COLUMNS, IGNORED_QUALIFIERS, HEADER_ROW_SEARCH_DEPTH, GRADE_FORMAT_NOTES, VALUE_NOTES} from './studentImportColumns'
import {parseImportNotes, hasImportNotes} from './parseImportNotes'
const ArchiveFilesType={
    dataSync:'Data Sync',
    studentImport:'Student Import'
}
const modalStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        width: '50%',
        maxHeight: '85vh',
        overflowY: 'auto',
        transform: 'translate(-50%, -50%)'
    }
};
const modEnum=getModuleEnum();
class setUpSchool extends Component {
    constructor() {
        super();
        this.state = {
            loading: false,
            archiveFiles:[],
            validGrades: [],
            gradeLabelMap: {},
            resultModalIsOpen: false,
            resultIsError: false,
            resultSummary: '',
            skippedRows: [],
            skippedCount: 0,
            ignoredHeaders: [],
            rejectedStudents: [],
            importCounts: null,
            isStudentImport: getAccessLevelByModule(modEnum.SIU)?true: (getAccessLevelByModule(modEnum.SSISI)?false:false)
        }
        this.textInput = React.createRef();
        this.getArchiveFiles=this.getArchiveFiles.bind(this)

    }
    componentWillMount=()=>{
        this.getArchiveFiles();
        this.loadSchoolGrades();
    }

    componentDidMount() {
        this._notificationSystem = this.refs.notificationSystem;
    }


    uploadClick(e,callback) {
        
        let userInfo = JSON.parse(sessionStorage.getItem('loggedInUserInfo'));
        let schoolId = userInfo.schoolId;
        let userName = userInfo.username;
        if(document.getElementById('schoolFile').value.length<=0){
            _addNotificationError('Please select file.', this);
            callback(true);
            return false;
        }
        let fileInput = document.getElementById('schoolFile').files[0];
        var data = new FormData();
        data.append('file', fileInput);
        //console.log('data', data);
        this.setState({loading: true})

        postResponse('/importStudents?schoolId=' + schoolId + '&loggedUser=' + userName + '&schoolYear='+sessionStorage.getItem('schoolYearValue')+'&access_token=', data).then((response) => {
            console.log('response', response);
            // Skipped-row and ignored-header notes are appended to both statusMessage
            // and errorMessage even when the import succeeded, so statusCode alone
            // decides success here - a non-empty errorMessage is not a failure.
            const notes = parseImportNotes(response.statusMessage, response.errorMessage);
            // The rows the API rejected outright are reported separately from the
            // skipped-row note, and only this list carries the student details.
            const rejected = this.flattenRejectedStudents(response.rejectedStudentsInfos);
            const counts = this.buildImportCounts(response, notes, rejected.length);
            this.setState({loading: false});
            callback(true);

            if (response.statusCode !== 200) {
                const failure = notes.remainder || 'Unable to import the students. Please contact administrator.';
                _addNotificationError(failure, this);
                this.showImportResult(true, failure, notes, rejected, counts);
                return;
            }

            const summary = notes.remainder || 'Students added successfully.';
            if (rejected.length > 0) {
                // A 200 can still carry rejected rows, so the message must not read as a clean success.
                _addNotificationError(rejected.length + ' record(s) in this file could not be imported.', this);
            } else {
                _addNotification(summary, this);
            }
            if (hasImportNotes(notes) || rejected.length > 0) {
                // Keep the notes on screen instead of redirecting out from under them.
                this.showImportResult(false, summary, notes, rejected, counts);
                return;
            }
            setTimeout(() => {
                this.context.router.history.push('/schoolAdmin/manageSchool')
            }, 3000);
        }).catch(
            (error) => {
                 _addNotificationError(error.message,this);
                this.setState({loading: false});
                callback(true);
                console.log('Import students response', error)
            }
        )
    };
    getArchiveFiles() {
        this.setState({loading: true})
        let userInfo = JSON.parse(sessionStorage.getItem('loggedInUserInfo'));
        let schoolId = userInfo.schoolId;
        let archType=this.state.isStudentImport?ArchiveFilesType.studentImport:ArchiveFilesType.dataSync
       get('/studentBkpFileHistories/search/studentBkpHstry?mealSchoolId=' + schoolId + '&schoolYear=' + sessionStorage.getItem('schoolYearValue') +'&type='+archType+ '&limitVal=100000&access_token=').then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {

            console.log(JSON.stringify(data._embedded.studentBkpFileHistories, null, 2));
            this.setState({
                archiveFiles: data._embedded.studentBkpFileHistories,loading: false
            });
        }).catch(
            (error) => {
                this.setState({
                    archiveFiles: [],loading: false
                });
                console.log('Archive files errors:', error)
            }
        );
    }
    /** Flattens rejectedStudentsInfos into one row per student, carrying its group's reason. */
    flattenRejectedStudents=(rejectedStudentsInfos)=>{
        return (rejectedStudentsInfos || []).reduce((rows, group)=>{
            const reason = (group || {}).errorMessage || (group || {}).status || 'Not imported';
            return rows.concat(((group || {}).studentUsers || []).map(student=>({
                studentId: student.studentId,
                name: ((student.firstName || '') + ' ' + (student.lastName || '')).trim(),
                grade: student.gradeName,
                reason: reason
            })));
        }, []);
    }
    buildImportCounts=(response, notes, rejectedCount)=>{
        const failed = (response.failedInsertCount || 0) + (response.failedUpdateCount || 0);
        return {
            added: response.successInsertCount || 0,
            updated: response.successUpdateCount || 0,
            // The counts can come back as 0 while the rejected list is populated.
            failed: failed > 0 ? failed : rejectedCount,
            skipped: notes.skippedCount || response.skipRecCount || 0
        };
    }
    showImportResult=(isError, summary, notes, rejectedStudents, counts)=>{
        this.setState({
            resultModalIsOpen: true,
            resultIsError: isError,
            resultSummary: summary,
            skippedRows: notes.skippedRows,
            skippedCount: notes.skippedCount,
            ignoredHeaders: notes.ignoredHeaders,
            rejectedStudents: rejectedStudents || [],
            importCounts: counts || null
        });
    }
    closeImportResult=()=>{
        const isSuccess = !this.state.resultIsError;
        this.setState({resultModalIsOpen: false}, ()=>{
            if (isSuccess) {
                this.context.router.history.push('/schoolAdmin/manageSchool')
            }
        });
    }
    loadSchoolGrades=()=>{
        get('/mealSchools/' + sessionStorage.getItem('SchoolId') + '/school?access_token=').then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {
            let grades = [];
            Object.values(data.typeGrades || {}).forEach(typeGrades => {
                (typeGrades || []).forEach(grade => {
                    // The same grade can be configured under more than one school type.
                    if (grade !== null && grade !== undefined && grade !== '' && grades.indexOf(grade) < 0) {
                        grades.push(grade);
                    }
                });
            });
            let gradeLabelMap = {};
            getSchoolGrades(0, false).forEach(item => {
                gradeLabelMap[String(item.value)] = item.label;
            });
            this.setState({validGrades: sortGrade(grades), gradeLabelMap: gradeLabelMap});
        }).catch(
            (error) => {
                // The grade list is advisory - a failure here must not block the upload.
                this.setState({validGrades: [], gradeLabelMap: {}});
                console.log('Get school grades response', error)
            }
        );
    }
    gradeLabel=(grade)=>{
        return this.state.gradeLabelMap[String(grade)] || String(grade);
    }
    isValidSchoolYearToImport=()=>{
        const schoolYears=JSON.parse(sessionStorage.getItem('schoolYearsList')).map(sy=>sy.schoolYear);
        const selectedSchoolYear= numberParce(sessionStorage.getItem('schoolYearValue')); 
        const activeSchoolYear=JSON.parse(sessionStorage.getItem('loggedInUserInfo')).schoolYear;
        const schoolYearSubArrays=schoolYears.slice(schoolYears.indexOf(activeSchoolYear),(schoolYears.length));
        return schoolYearSubArrays.includes(selectedSchoolYear);
    }
    render() {        
        const checkboxProps = {

            getTheadProps: () => {
                return {
                    style: {
                        backgroundColor: "#D2D7D4", fontWeight: 'bold'
                        // color: selected ? 'white' : 'inherit',
                    },
                    className: "bg-success base-reverse"
                };
            },
            getTableProps: () => {
                return {
                    className: "table table-hover"
                }
            },
        };
        const {validGrades, skippedRows, ignoredHeaders, resultIsError, rejectedStudents, importCounts} = this.state;
        const hasFailures = resultIsError || rejectedStudents.length > 0;
        return (
            <section className="full-width clearfix">
                <NotificationSystem ref="notificationSystem"/>
                <div className='sweet-loading' style={{position: 'fixed', top: '50%', left: '48%', zIndex: '1000'}}>
                    <BeatLoader
                        size={20}
                        color={'#ea7066'}
                        loading={this.state.loading}
                    />
                </div>
                <div className="container">
                    <div className="sectionTitle">
                        <h2>
                            <span>Import Students Info for: {sessionStorage.getItem('schoolYear')}</span>
                        </h2>
                    </div>

                    <div className="row">
                    {
                        getAccessLevelByModule(modEnum.SIU)?
                        <div className="col-md-4 text-center">
                            <div className="panel panel-primary">
                                <div className="panel-heading text-center"><h3 className="panel-title"> Students
                                    Info</h3></div>
                                <div className="panel-body">
                                    <div className="uploadFileInfo">
                                        <div className="form-group col-md-12 createmenu-link-group">
                                            <p>You can setup the school using excel(<b>.xls</b>,<b> .xlsx</b>) or CSV (<b>.csv</b>) file.
                                                Upload it to load the student data. Download <a
                                                    href="https://s3.amazonaws.com/mealmanage-prod/SampleFiles/Students.xlsx"
                                                    download>Sample
                                                    file</a>
                                            </p>
                                        </div>

                                        {validGrades.length>0?
                                        <div className="form-group col-md-12" style={{textAlign: 'left'}}>
                                            <label className="control-label" style={{display: 'block'}}>Valid grades for this school</label>
                                            <div>
                                                {validGrades.map((grade, index)=>(
                                                    <span key={index} className="label label-default"
                                                          style={{display: 'inline-block', margin: '0 4px 4px 0', fontSize: '12px'}}>
                                                        {this.gradeLabel(grade)}
                                                    </span>
                                                ))}
                                            </div>
                                            <p style={{fontSize: '12px', fontStyle: 'italic', marginTop: '5px'}}>
                                                Rows with a Grade that is not in this list are skipped, and are listed after the upload.
                                            </p>
                                        </div>:null
                                        }

                                        {this.isValidSchoolYearToImport()?

                                        <Fragment>
                                            <div className="input-group">
                                            <label className="control-label"> Upload Excel File </label>
                                            <input type="file" className="form-control" 
                                             accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                                   style={{opacity: '1', zIndex: '2'}}  ref={this.textInput}
                                                   id="schoolFile" aria-describedby="basic-addon21" onChange={(e)=>{
                                                        let validExts = new Array(".xlsx", ".xls", ".csv");
                                                        let fileExt = e.target.files[0].name.split('.').pop();
                                                        const fileSize = e.target.files[0].size;
                                                        const fileMb = fileSize / 1024 ** 2;
                                                        if (validExts.indexOf('.'+fileExt) < 0) {
                                                            _addNotificationError("Invalid file format. Please select valid file format (" +
                                                                validExts.toString() + ")",this);
                                                            e.target.value='';
                                                        return false;
                                                        }else if(fileMb >= 2){
                                                            _addNotificationError("Please select a file less than 2MB.",this);
                                                            e.target.value='';
                                                            return false;
                                                        }
                                                        else return true;
                                                   }}/>
                                            <button id="OpenUpload" onClick={()=>{$('#schoolFile').click()}}
                                                    className="control-label input-group-addon"><i
                                                className="fa fa-upload"
                                                aria-hidden="true"/></button>
                                        </div>
                                        <div className="form-group col-md-12 text-center">
                                            <CustomSubmit type="submit" id="submit" handleSubmit={(e,callback)=>this.uploadClick(e,callback)}
                                                    className="btn btn-sm btn-primary"><i
                                                className="fa fa-arrow-circle-right"></i><span>Proceed</span>
                                            </CustomSubmit>
                                        </div>
                                    </Fragment>:                                        
                                        <div className="text-center" style={{fontSize: '23px', fontStyle: 'italic', color: 'red'}}>
                                        <span>Please select active/upcoming school year</span>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                    <div className="panel-group" id="importColumnsHelp" style={{marginTop: '15px'}}>
                        <div className="panel panel-primary">
                            <div className="panel-heading">
                                <h3 className="panel-title">
                                    <a data-toggle="collapse" data-parent="#importColumnsHelp" href="#acceptedColumns"
                                       style={{color: '#fff', textDecoration: 'none', display: 'block'}}>
                                        <i className="fa fa-table" aria-hidden="true"/> Accepted column headers
                                        <i className="fa fa-chevron-down pull-right" aria-hidden="true"/>
                                    </a>
                                </h3>
                            </div>
                            <div id="acceptedColumns" className="panel-collapse collapse">
                                <div className="panel-body" style={{textAlign: 'left', fontSize: '12px'}}>
                                    <div className="alert alert-info" style={{padding: '8px', fontSize: '12px'}}>
                                        <strong>Parent Email</strong> must be present as a column or the file is rejected before any
                                        row is read, but the cell may be left blank for an individual student. A blank Parent Email
                                        falls back to <strong>Parent Alternate Email</strong>, and is stored as <code>NA</code> when
                                        both are blank.
                                    </div>
                                    <table className="table table-condensed" style={{fontSize: '12px'}}>
                                        <thead>
                                            <tr style={{backgroundColor: '#D2D7D4'}}>
                                                <th>Field</th>
                                                <th>Accepted headers</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {STUDENT_IMPORT_COLUMNS.map(column=>(
                                                <tr key={column.field}>
                                                    <td style={{whiteSpace: 'nowrap'}}>
                                                        {column.field}
                                                        {column.requiredColumn?
                                                            <span style={{color: 'red'}} title="Required column"> *</span>:null}
                                                    </td>
                                                    <td>
                                                        {column.headers.map((header, index)=>(
                                                            <Fragment key={header}>
                                                                {index>0?', ':''}<code>{header}</code>
                                                            </Fragment>
                                                        ))}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                    <p><span style={{color: 'red'}}>*</span> The column must be present in the sheet.</p>
                                    <p><strong>How headers are matched</strong></p>
                                    <ul style={{paddingLeft: '18px'}}>
                                        <li>A header must match one of the accepted headers above exactly - a near match is not
                                            enough. Upper/lower case, line breaks and repeated spaces are ignored.</li>
                                        <li>These qualifiers are ignored anywhere in a header:{' '}
                                            {IGNORED_QUALIFIERS.map((qualifier, index)=>(
                                                <Fragment key={qualifier}>
                                                    {index>0?', ':''}<code>{qualifier}</code>
                                                </Fragment>
                                            ))} - so <code>Before Care (Yes/No/Blank) (Optional)</code> is matched
                                            as <code>before care</code>.</li>
                                        <li>The header row may be anywhere in the first {HEADER_ROW_SEARCH_DEPTH} rows, so a title
                                            or sub-header row above it is fine.</li>
                                        <li>Any header that is not in the list above is ignored, and is listed after the upload.</li>
                                    </ul>
                                    <p><strong>Grade values</strong></p>
                                    <ul style={{paddingLeft: '18px'}}>
                                        {GRADE_FORMAT_NOTES.map(note=>(<li key={note}>{note}</li>))}
                                    </ul>
                                    <p><strong>How cell values are read</strong></p>
                                    <ul style={{paddingLeft: '18px'}}>
                                        {VALUE_NOTES.map(note=>(<li key={note}>{note}</li>))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>:null
            }
                        <div className="col-md-8 text-center">
                            <div className="panel panel-primary">
                                <div className="panel-heading text-center"><h3 className="panel-title">Archive Files</h3></div>
                                <div className="panel-body">
                                {
                                    getAccessLevelByModule(modEnum.SIU) &&  getAccessLevelByModule(modEnum.SSISI)?
                                <div className="row">
                                    <div className="col-md-12">
                                    <div style={{display:'inline-block',marginLeft: '50px'}}>
                                <label style={{display:'block',width:'100%'}}>
                                <span className='custom-label' style={{paddingRight:'10px',color:'#b5d56a'}}>{ArchiveFilesType.studentImport}</span>
                                <Toggle
                                    checked={(this.state.isStudentImport) ? true : this.state.isStudentImport}
                                    icons={{
                                        checked: <i className='fa fa-check' style={{fontSize: '13px'}} />,
                                        unchecked: <i className='fa fa-check' style={{fontSize: '13px'}} />,
                                        }}                                  
                                    onChange={(e) => {
                                        this.setState({isStudentImport:e.target.checked},
                                        ()=>{this.getArchiveFiles();});                                        
                                        }} />
                                <span className='custom-label' style={{paddingLeft:'10px',color:'#a597e7'}}>{ArchiveFilesType.dataSync}</span>
                                </label>
                                
                            </div>
                                    </div>
                                </div>:null
                                }
                                <div className="row">
                                    <div className="col-md-12">
                                    <ReactTable {...checkboxProps}
                                data={this.state.archiveFiles}
                                columns={[
                                    {
                                        Header: 'Date',
                                        style: {textAlign: 'left',fontSize:'14px'},
                                        
                                        Cell: ({row}) => (
                                             moment(row._original.date).format(date_format()+'  '+'hh:MM a')),
                                        
                                    },
                                    {
                                        Header: 'Processed By',
                                        style: {textAlign: 'left',fontSize:'14px'},
                                       
                                        Cell: ({row}) => (
                                             row._original.createdBy)                                        
                                        
                                    },
                                    {
                                        Header: 'File',
                                        style: {textAlign: 'center',fontSize:'13px'},
                                        Cell: ({row}) => (
                                            <a title={'Click here download'} href={row._original.fileS3Link}>
                                             <i style={{fontSize: '25px'}} className="fa fa-file-excel-o"></i></a>)
                                    }
                                ]}
                                defaultPageSize={5}
                                 />

                                    </div>
                                </div>
                                </div>
                            </div>
                        </div> 
                    </div>                   
                </div>
                <Modal isOpen={this.state.resultModalIsOpen} style={modalStyles}
                       onRequestClose={this.closeImportResult} contentLabel="Import Result">
                    <div className="modal-header">
                        <h4 className="modal-title modal-title-color" id="importResultLabel">
                            {resultIsError? 'Import Failed':(rejectedStudents.length>0? 'Import Result - Some Records Failed':'Import Result')}
                        </h4>
                    </div>
                    <div className="modal-body">
                        <div className="row">
                            <div className="col-md-12">
                                <p className="text-center" style={{
                                    fontSize: '13px',
                                    fontWeight: '600',
                                    color: hasFailures? 'red':'inherit'
                                }}>
                                    <strong>{this.state.resultSummary}</strong>
                                </p>
                                {importCounts &&
                                <p className="text-center" style={{fontSize: '13px'}}>
                                    <span>Added: {importCounts.added}</span>
                                    <span style={{marginLeft: '10px'}}>Updated: {importCounts.updated}</span>
                                    <span style={{marginLeft: '10px', color: importCounts.failed>0? 'red':'inherit'}}>
                                        Failed: {importCounts.failed}</span>
                                    <span style={{marginLeft: '10px'}}>Skipped: {importCounts.skipped}</span>
                                </p> }
                            </div>
                        </div>
                        {rejectedStudents.length>0 &&
                        <div className="row">
                            <div className="col-md-12">
                                <p className="color-1" style={{fontSize: '13px', fontWeight: '600'}}>
                                    <strong>Note:</strong> These students were not imported. Correct the listed value in the file
                                    and upload it again to add them.
                                    {validGrades.length>0 && <span> Valid grades for this school: {validGrades.map(grade=>this.gradeLabel(grade)).join(', ')}.</span>}
                                </p>
                                <span style={{color: 'red', textDecoration: 'underline'}}>Records not imported:</span>
                                <span className="pull-right">Count:{rejectedStudents.length}</span>
                                <ReactTable {...checkboxProps}
                                    data={rejectedStudents}
                                    columns={[
                                        {
                                            Header: 'Student ID',
                                            style: {textAlign: 'left', fontSize: '13px'},
                                            Cell: ({row}) => (row._original.studentId || 'Unknown')
                                        },
                                        {
                                            Header: 'Name',
                                            style: {textAlign: 'left', fontSize: '13px'},
                                            Cell: ({row}) => (row._original.name || '')
                                        },
                                        {
                                            Header: 'Grade in file',
                                            style: {textAlign: 'left', fontSize: '13px'},
                                            Cell: ({row}) => (row._original.grade || '(blank)')
                                        },
                                        {
                                            Header: 'Reason',
                                            style: {textAlign: 'left', fontSize: '13px'},
                                            Cell: ({row}) => (row._original.reason)
                                        }
                                    ]}
                                    defaultPageSize={rejectedStudents.length>5? 5: rejectedStudents.length}
                                    showPagination={rejectedStudents.length>5}
                                 />
                            </div>
                        </div> }
                        {skippedRows.length>0 &&
                        <div className="row">
                            <div className="col-md-12">
                                <p className="color-1" style={{fontSize: '13px', fontWeight: '600'}}>
                                    <strong>Note:</strong> These rows were skipped because their Grade is not configured for this
                                    school. Correct the Grade column to one of the school's valid grades and upload the file again
                                    to add them.
                                </p>
                                <span style={{color: 'red', textDecoration: 'underline'}}>Skipped rows:</span>
                                <span className="pull-right">Count:{this.state.skippedCount || skippedRows.length}</span>
                                <ReactTable {...checkboxProps}
                                    data={skippedRows}
                                    columns={[
                                        {
                                            Header: 'Student ID',
                                            style: {textAlign: 'left', fontSize: '13px'},
                                            Cell: ({row}) => (row._original.studentId || 'Unknown')
                                        },
                                        {
                                            Header: 'Grade in file',
                                            style: {textAlign: 'left', fontSize: '13px'},
                                            Cell: ({row}) => (row._original.grade || '(blank)')
                                        }
                                    ]}
                                    defaultPageSize={skippedRows.length>5? 5: skippedRows.length}
                                    showPagination={skippedRows.length>5}
                                 />
                            </div>
                        </div> }
                        {ignoredHeaders.length>0 &&
                        <div className="row" style={{marginTop: '10px'}}>
                            <div className="col-md-12">
                                <p className="color-1" style={{fontSize: '13px', fontWeight: '600'}}>
                                    <strong>Note:</strong> These headers were ignored because they are not supported. Anything in
                                    those columns was not imported.
                                </p>
                                <span style={{color: 'red', textDecoration: 'underline'}}>Ignored headers:</span>
                                <span className="pull-right">Count:{ignoredHeaders.length}</span>
                                <div className="row">
                                    {ignoredHeaders.map((header, index)=>(
                                        <div className="col-md-4" key={index}>
                                            <i className="fa fa-hand-o-right"></i> {header}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div> }
                    </div>
                    <div className="modal-footer">
                        <div className="text-right">
                            <button type="button" className="btn btn-success btn-xs" style={{margin: '0 0 0 5px'}}
                                    onClick={this.closeImportResult} id="importResultOk">
                                <i className="glyphicon glyphicon-ok"></i> Ok
                            </button>
                        </div>
                    </div>
                </Modal>
            </section>

        );
    }

}

setUpSchool.contextTypes = {
    router: PropTypes.object.isRequired
}

export default setUpSchool;



// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/SetUpSchool/setUpSchool.jsx